import React from 'react';
import { FormattedTimestamp } from '@xingternal/pages-common';
import { SkeletonBody } from '@xingternal/skeleton';
import { BodyCopy, Meta } from '@xingternal/typography';
import { getTrackingUrl } from '@xingternal/pages-tracking';
import cx from 'classnames';
import styles from './JobsListItem.css';

import JobsBookmark from '../../JobsBookmark';

const JobsListItemSkeleton = () => (
  <div className={styles.container}>
    <SkeletonBody
      variant="primary"
      size="medium"
      amountRows={3}
      className={styles.skeleton}
    />
  </div>
);

type JobsListItemProps = {
  title: string;
  companyName: string;
  city: string;
  activatedAt: Date;
  url: string;
  id: string;
  bookmarkState: boolean;
  showBookmark: boolean;
  descriptionHighlight: string;
  showDescription: boolean;
};

const JobsListItem: React.FC<JobsListItemProps> = ({
  title,
  companyName,
  city,
  activatedAt,
  url,
  id,
  bookmarkState,
  showBookmark,
  descriptionHighlight,
  showDescription,
}) => (
  <div className={cx(styles.container, styles.containerHover)}>
    <a
      className={styles.infoWrapper}
      href={getTrackingUrl({
        to: url,
        trackingKey: 'viewJobProfile',
      })}
      target="_blank"
    >
      <BodyCopy
        fontWeight="bold"
        lineHeight="dense"
        size={'large'}
        noMargin
        className={styles.headline}
      >
        {title}
      </BodyCopy>
      {showDescription && (
        /* @ts-ignore */
        <BodyCopy
          size={'small'}
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: descriptionHighlight }}
        />
      )}
      <BodyCopy noMargin size={'medium'} className={styles.companyInfo}>
        {`${companyName}, ${city}`}
      </BodyCopy>
      <Meta noMargin size={'small'} className={styles.meta}>
        <FormattedTimestamp date={activatedAt} />
      </Meta>
    </a>
    {showBookmark && (
      <JobsBookmark jobId={id} bookmarked={bookmarkState} isSubpage={true} />
    )}
  </div>
);

export { JobsListItem, JobsListItemSkeleton };
